import MiniCalendar from "components/calendar/MiniCalendar";
import WeeklyRevenue from "views/admin/default/components/WeeklyRevenue";
import ActivatedDevicesGraph from "./components/ActivatedDevicesGraph";
import PLWisePieChart from "./components/PLWisePieChart";
import {IoMdHome} from "react-icons/io";
import {IoDocuments, IoShieldCheckmark} from "react-icons/io5";
import {
    MdAccessibilityNew,
    MdBarChart,
    MdDashboard,
    MdDevices,
    MdMobileFriendly, MdOutlineBarChart,
    MdPeople,
    MdPeopleOutline, MdPerson
} from "react-icons/md";
import React, {useEffect, useState} from "react";
import {AES, enc} from 'crypto-js';
import axios from "axios";


import {columnsDataCheck, columnsDataComplex} from "./variables/columnsData";

import Widget from "components/widget/Widget";

import {useUserAuth} from "../../../context/UserAuthContext";
import {useNavigate} from "react-router-dom";
import RegisteredUsersGraph from "./components/RegisteredUsersGraph";
import useAsyncEffect from "use-async-effect";
import DevicesPerProductGraph from "./components/DevicesPerProductGraph";
import LocationDemographicsTable from "./components/LocationDemographicsTable";
import Alerts from "../error";
import HeatMap from "./components/HeatMap";
import {getLastCompleteMonthPeriod, getPreviousMonthValue} from "utils/reportingPeriod";

const Dashboard = () => {

        var sv = "";
        const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
        const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

        //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
        //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
        const secretKey = "cromptonssecretkey";

        let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
        const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
        const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
        const navigate = useNavigate();

        const [summaryValues, setSummaryValues] = useState([]);
        const [locationJsonResult, setLocationJsonResult] = useState([]);
        const [summaryNumberValues, setSummaryNumberValues] = useState([]);

        var stats = [];
        var statsNumber = [];
        const [isLoading, setIsLoading] = useState(true);

        const [message, setErrorMessage] = useState("");
        const reportingPeriod = getLastCompleteMonthPeriod();
        const previousMonthValues = summaryNumberValues.slice(0, 6).map((value, index) =>
            getPreviousMonthValue(value, summaryNumberValues[index + 6])
        );

        const handleLogOut = async () => {
            try {
                await logOut();
                navigate("/");
            } catch (error) {
                ////console.log(error.message);
            }
        }

        useAsyncEffect(async () => {
                async function getOverallSummary() {
                    if ((accesscontrollevel.toString() === "1") || (accesscontrollevel.toString() === "3") || (accesscontrollevel.toString() === "5")) {
                        var url = CROMPTON_ANALYTICS_URL + "v1/user/statistics"

                        axios({
                            method: "GET", url: url, headers: {
                                Authorization: decryptedValue,
                            }

                        }).then((res) => {
                            //console.log(res.data)
                            for (var i in res.data) {
                                stats.push(i);
                                statsNumber.push(res.data[i])
                            }
                            setSummaryValues(stats);
                            setSummaryNumberValues(statsNumber);

                            //console.log(summaryValues)
                            //console.log(summaryNumberValues)

                            sessionStorage.setItem("AnalyticsSummary", JSON.stringify(res.data))

                            setIsLoading(false)
                            //getMonthlyRegisteredUsersTrend()


                        }).catch((error) => {
                            setIsLoading(false)
                            if (error.response.data.status === "401" || error.response.data.status === "403") {
                                handleLogOut();
                            }
                        })

                    } else {
                        setIsLoading(false)
                        //console.log("Inside stats non admin")
                        setErrorMessage("You do not have permission to view this. Please contact admin.")
                    }
                }

                function getLocationDemographicsByState() {
                    if ((accesscontrollevel.toString() === "1") || (accesscontrollevel.toString() === "3") || (accesscontrollevel.toString() === "5")) {
                        var url = CROMPTON_ANALYTICS_URL + "v1/user/location/states"
                        axios({
                            method: "GET", url: url, headers: {
                                Authorization: decryptedValue,
                            }

                        }).then((res) => {
                            //console.log(res.data)

                            var state = []
                            var count = [];
                            for (var i = 0; i < res.data.length; i++) {
                                state.push(res.data[i].state);
                                count.push(res.data[i].count);
                            }

                            setLocationJsonResult(res.data)

                        }).catch((error) => {
                            //console.log(error)
                            if (error.response.data.status === "401" || error.response.data.status === "403") {
                                handleLogOut();
                            }
                        })
                    } else {
                        //console.log("Inside stats non admin")
                        setErrorMessage("You do not have permission to view this. Please contact admin.")
                    }

                }

                function getProductCatalog() {
                    var chartLabels = [];
                    var count = [];
                    var url = CROMPTON_ANALYTICS_URL + "v1/device/v2/products"
                    axios({
                        method: "GET", url: url, headers: {
                            Authorization: decryptedValue,
                        }

                    }).then((res) => {
                        //console.log(res.data)
                        for (var i in res.data) {
                            chartLabels.push((res.data[i].productId))
                            count.push(res.data[i].product)
                        }

                        sessionStorage.setItem("productCatalogArray", JSON.stringify(res.data))

                        /*localStorage.setItem("productId", JSON.stringify(chartLabels))
                        localStorage.setItem("productNames", JSON.stringify(count))*/

                        //getDevicesPerProduct()

                        /*console.log("Data labels: ", chartLabels)
                        console.log("Data values: ", count)*/

                    }).catch((error) => {
                        //console.log(error)
                        if (error.response.data.status === "401" || error.response.data.status === "403") {
                            handleLogOut();
                        }
                    })

                }

                await getOverallSummary()

                getLocationDemographicsByState()

                getProductCatalog()

            }, [sv]
        );


        return (
            !isLoading &&
            <div>
                {/* Card widget */}

                {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || accesscontrollevel.toString() === "5" ?

                    <div
                        className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
                        <Widget
                            icon={<MdPeople className="h-7 w-7 text-[#004c86] dark:text-white"/>}
                            title={"Total Registered Users"}
                            subtitle={previousMonthValues[0] === "--" ? "--" : previousMonthValues[0] + "*"}
                            percentage={summaryNumberValues[6]}
                        />
                        <Widget
                            icon={<IoShieldCheckmark className="h-6 w-6 text-[#004c86] dark:text-white"/>}
                            title={"Average Active Users"}
                            subtitle={previousMonthValues[2]}
                            percentage={summaryNumberValues[8]}
                        />
                        <Widget
                            icon={<MdAccessibilityNew className="h-7 w-7 text-[#004c86] dark:text-white"/>}
                            title={reportingPeriod.monthName + " Registrations"}
                            subtitle={previousMonthValues[1]}
                            percentage={summaryNumberValues[7]}
                        />
                        <Widget
                            icon={<MdDevices className="h-6 w-6 text-[#004c86] dark:text-white"/>}
                            title={"Total Activated Devices"}
                            subtitle={previousMonthValues[3] === "--" ? "--" : previousMonthValues[3] + "*"}
                            percentage={summaryNumberValues[9]}
                        />
                        <Widget
                            icon={<IoShieldCheckmark className="h-7 w-7 text-[#004c86] dark:text-white"/>}
                            title={reportingPeriod.monthName + " Active Devices"}
                            subtitle={previousMonthValues[5]}
                            percentage={summaryNumberValues[11]}
                        />
                        <Widget
                            icon={<MdMobileFriendly className="h-6 w-6 text-[#004c86] dark:text-white"/>}
                            title={reportingPeriod.monthName + " Activated"}
                            subtitle={previousMonthValues[4]}
                            percentage={summaryNumberValues[10]}
                        />
                    </div>
                    :
                    <div
                        className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
                        <Widget
                            icon={<MdPeople className="h-7 w-7 text-[#004c86] dark:text-white"/>}
                            title={"Total Registered Users"}
                            subtitle={"--"}
                        />
                        <Widget
                            icon={<IoShieldCheckmark className="h-6 w-6 text-[#004c86] dark:text-white"/>}
                            title={"Average Active Users"}
                            subtitle={"--"}
                        />
                        <Widget
                            icon={<MdAccessibilityNew className="h-7 w-7 text-[#004c86] dark:text-white"/>}
                            title={reportingPeriod.monthName + " Registrations"}
                            subtitle={"--"}
                        />
                        <Widget
                            icon={<MdDevices className="h-6 w-6 text-[#004c86] dark:text-white"/>}
                            title={"Total Activated Devices"}
                            subtitle={"--"}
                        />
                        <Widget
                            icon={<IoShieldCheckmark className="h-7 w-7 text-[#004c86] dark:text-white"/>}
                            title={reportingPeriod.monthName + " Active Devices"}
                            subtitle={"--"}
                        />
                        <Widget
                            icon={<MdMobileFriendly className="h-6 w-6 text-[#004c86] dark:text-white"/>}
                            title={reportingPeriod.monthName + " Activated"}
                            subtitle={"--"}
                        />
                    </div>
                }


                {/* Charts */}

                {/*{accesscontrollevel === 4 ?

                        <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
                            <RegisteredUsersGraph/>
                            <ActivatedDevicesGraph/>
                        </div> :
                    <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
                        <Alerts/>
                        <Alerts/>
                    </div>

                }*/}

                <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
                    {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || accesscontrollevel.toString() === "4" || (accesscontrollevel.toString() === "5")?
                        <RegisteredUsersGraph/> : <Alerts/>}
                    {accesscontrollevel.toString() === "1" || (accesscontrollevel.toString() === "5")? <ActivatedDevicesGraph/> : <Alerts/>}
                </div>


                {/* Tables & Charts */}

                <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
                    {/* Check Table */}
                    <div>
                        {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || (accesscontrollevel.toString() === "5")?
                            <DevicesPerProductGraph/> : <Alerts/>}
                    </div>

                    {/* Traffic chart & Pie Chart */}

                    <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
                        {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || (accesscontrollevel.toString() === "5")?
                            <LocationDemographicsTable
                                columnsData={[
                                    {
                                        Header: "SR",
                                        accessor: "sr",
                                    },
                                    {
                                        Header: "STATE",
                                        accessor: "state",
                                    },
                                    {
                                        Header: "COUNT",
                                        accessor: "count",
                                    },
                                ]}
                                tableData={locationJsonResult}
                            /> : <Alerts/>}
                        {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || accesscontrollevel.toString() === "2" || (accesscontrollevel.toString() === "5")?
                            <PLWisePieChart/> : <Alerts/>}
                    </div>

                    {/* Complex Table , Task & Calendar */}

                    {/* <ComplexTable
                    columnsData={columnsDataComplex}
                    tableData={tableDataComplex}
                />*/}

                    {/* Task chart & Calendar */}

                    {/*<div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-1">
                        <HeatMap/>
                        <TaskCard/>
                    <div className="grid grid-cols-1 rounded-[20px]">
                        <MiniCalendar/>
                    </div>
                    </div>*/}
                </div>
            </div>
        )
            ;
    }
;

export default Dashboard;
